import { format } from 'date-fns'

import { createBaseTableStore } from '../table'
import type { FetchApiArgs, FetchApiResponse } from '../table/table.types'
import { fetchTournamentsWithFeedCount, GolfTournamentWithFeedCount } from './tournaments.utils'

export type FilterParams = 'dateFrom' | 'dateTo'

const fetchTournamentsApiCallback = async (
  args: FetchApiArgs<object, string, FilterParams>
): Promise<FetchApiResponse<GolfTournamentWithFeedCount>> => {
  const { signal, filters } = args

  const dateFrom = filters?.dateFrom?.[0]?.value
    ? format(filters.dateFrom[0].value?.toString(), 'yyyy-MM-dd')
    : undefined

  const dateTo = filters?.dateTo?.[0]?.value
    ? format(filters.dateTo[0].value?.toString(), 'yyyy-MM-dd')
    : undefined

  const tournamentsWithFeedCount = await fetchTournamentsWithFeedCount({
    dateFrom,
    dateTo,
    signal
  })

  return {
    content: tournamentsWithFeedCount,
    totalElements: tournamentsWithFeedCount.length
  }
}

export const useTournaments = createBaseTableStore({
  storeName: 'Tournaments',
  fetchApi: fetchTournamentsApiCallback,
  features: {
    filtering: true
  }
})
